// Eagerly import all markdown posts using Vite's glob import
const postModules = import.meta.glob<{ html: string; md: string }>(
    './posts/*.md',
    { eager: true }
);

/** Parsed metadata for a single blog post. */
export interface BlogPost {
    slug: string;
    date: string;
    title: string;
    html: string;
}

/**
 * Derive slug, date, and title from the filename + rendered HTML.
 * Expected filename format: YYYY-MM-DD-slug-words.md
 */
function parsePost(filepath: string, mod: { html: string }): BlogPost {
    const filename = filepath.split('/').pop()!.replace(/\.md$/, '');
    const match = filename.match(/^(\d{4}-\d{2}-\d{2})-(.+)$/);
    const date = match ? match[1] : '1970-01-01';
    const slug = match ? match[2] : filename;

    // Extract the first <h1> from the rendered HTML as the display title
    const titleMatch = mod.html.match(/<h1[^>]*>(.*?)<\/h1>/i);
    const title = titleMatch
        ? titleMatch[1].replace(/<[^>]*>/g, '')
        : slug.replace(/-/g, ' ');

    return { slug, date, title, html: mod.html };
}

/** Returns all posts sorted newest-first. */
export function getAllPosts(): BlogPost[] {
    const posts: BlogPost[] = [];
    for (const filepath in postModules) {
        posts.push(parsePost(filepath, postModules[filepath]));
    }
    posts.sort((a: BlogPost, b: BlogPost) => b.date.localeCompare(a.date));
    return posts;
}

/** Find a single post by slug. */
export function getPostBySlug(slug: string): BlogPost | undefined {
    return getAllPosts().find((p) => p.slug === slug);
}
